import styled from 'styled-components'

const Description = styled.div<{readonly error?: boolean}>`
    color: ${props => props.error === true ? '#F56363' : '#606060'};
    width: calc(100% - 32px);
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    margin: 24px 0 12px;

    &last-child {
        margin-bottom: 0;
    }

    @media (min-width: 481px) {
        margin: 22px 0 12px;
    }

    @media (min-width: 641px) {
        margin: 24px 0;
        width: 460px;
    }

    @media (min-width: 960px) {
        margin: 18px 0 24px;
        width: 610px;
    }

    &.form-description {
        width: 100%;
        font-size: 10px;
        line-height: 12px;
        text-align: center;
        color: ${props => props.error === true ? '#F56363' : '#9E9E9E'};
        margin: 12px 0;

        @media (min-width: 640px) {
            width: 534px;
            margin: 12px 0 0 40px;
            text-align: left;
            font-size: 12px;
            line-height: 16px;
        }
    }
`

Description.displayName = 'Description'

export default Description